import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getStatusTypes = createAsyncThunk('/getStatus', async () => {
  const response = await axios.get('/GetStatus');
  return response.data;
});

export const getStatusDetails = createAsyncThunk(
  '/getStatusDetails',
  async (ids) => {
    const response = await axios.get(`/GetStatusDetails/${ids}`);
    return response.data;
  }
);

export const getMobileStatusList = createAsyncThunk(
  '/getMobileStatusList',
  async () => {
    const response = await axios.get('/GetMobileStatusList/');
    return response.data;
  }
);

export const setCatalogItem = createAsyncThunk(
  '/SetCatalogItem',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetCatalogItem',
      data
    );
    return response.data;
  }
);

export const getLanguageList = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axiosHeadOffice.get('/Technician/GetLanguageList');
    return response.data;
  }
);

export const getTenantList = createAsyncThunk('/getTenantList', async () => {
  const response = await axiosHeadOffice.get('/Technician/GetTenantList');
  return response.data;
});


const statusSlice = createSlice({
  name: 'status',
  initialState: {
    selectedItemId: 0,
    loading: '',
    error: '',
    statusTypes: [],
    statusDescriptions: [],
    Tenants: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    IsOpen: true,
    IsComplete: false,
    IsStatusNoteRequired: false,
    IsAI:false,
    MobileStatus: '',
    MobileStatusId: 0,
    MobileStatusList: []
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    changeselectedItemId(state, action) {
      state.selectedItemId = action.payload;
    },
    resetDescriptions(state) {
      state.statusDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
    changeIsComplete(state, action) {
      state.IsComplete = action.payload;
    },
    changeIsStatusNoteRequired(state, action) {
      state.IsStatusNoteRequired = action.payload;
    },
    changeIsAI(state, action) {
      state.IsAI = action.payload;
    },
    changeTenants(state, action) {
      state.Tenants = action.payload;
    },
    changeIsOpen(state, action) {
      state.IsOpen = action.payload;
    },
    changeMobileStatus(state, action) {
      state.MobileStatus = action.payload;
      state.MobileStatusId = state.MobileStatusList.find((m) => m.Description === state.MobileStatus)?.ID;
    },
    changeMobileStatusId(state, action) {
      state.MobileStatusId = action.payload;
    },
  },
  extraReducers: {
    [getStatusTypes.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getStatusTypes.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getStatusTypes.fulfilled]: (state, action) => {
      state.statusTypes = action.payload;
      state.loading = 'Finished';
    },
    [getStatusDetails.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getStatusDetails.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getStatusDetails.fulfilled]: (state, action) => {
      state.statusDescriptions = action.payload;
      state.loading = 'Finished';
    },
    [getMobileStatusList.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getMobileStatusList.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getMobileStatusList.fulfilled]: (state, action) => {
      state.MobileStatusList = action.payload;
      state.loading = 'Finished';
    },

    [setCatalogItem.pending]: (state) => {
      state.loading = 'Loading';
    },
    [setCatalogItem.rejected]: (state, action) => {
      state.error = action.error;
    },
    [setCatalogItem.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = 'Finished';
    },
    [getLanguageList.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getLanguageList.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getLanguageList.fulfilled]: (state, action) => {
      state.statusDescriptions = action.payload;
      state.loading = 'Finished';
    },
    [getTenantList.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getTenantList.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getTenantList.fulfilled]: (state, action) => {
      state.Tenants = action.payload;
      state.loading = 'Finished';
    }
  }
});

export const statusActions = statusSlice.actions;

export default statusSlice;
